// const getAuthToken = () => 'JWT eyJhbGciOiJIUzI1NiJ9.eyJqdGkiOiI0MDkzZTBmMy00NTMyLTRmY2ItODNlZi02YmRlZjc2NGQ5MDkiLCJleHAiOjE2MjE1MzY2MjQsImZpcnN0X25hbWUiOiJRdXkiLCJsYXN0X25hbWUiOiJUaGkiLCJyb2xlX2lkIjoiOGU0YTY2NDUtNmY1YS00NTZmLWFlMWUtNjhlMWVhM2FhYjg1Iiwicm9sZV9uYW1lIjoiU3VwZXIgQWRtaW4iLCJyb2xlIjoiIzxSb2xlOjB4MDAwMDdmYjY3YzQ3NDg5MD4iLCJvcmdhbmlzYXRpb25faWQiOiI5NjU1OTk1Zi1jNjgyLTQ0ZTQtOWViZC04ODhhNDA0YjdiMTUiLCJwYXJ0bmVyX2lkIjpudWxsLCJpZCI6IjFkMDFiNTgzLTM1NDctNDY2ZC04NzI0LTBiY2YzYTgwODJkOSJ9.eizoA5cW8o8gV9L4Fv6as23wvlOZpb8gbf-DyIWOKrE'


// export { getAuthToken }
const loginTokenKey = "loginToken";
const userId = "userId";
const tokenExpiresAt = "tokenExpiresAt";
const refreshToken = "refreshToken";
const refreshTokenExpiresAt = "refreshTokenExpiresAt";

const getAuthToken = () => localStorage.getItem(loginTokenKey);
const setUserId = (id: string) => localStorage.setItem(userId, id);
const setAuthToken = (payload: any) => localStorage.setItem(loginTokenKey, payload);
const setAuthTokenExpiredTime = (time: string) => localStorage.setItem(tokenExpiresAt, time);
const getAuthTokenExpiredTime = () => localStorage.getItem(tokenExpiresAt);
const setRefreshToken = (refresh_token: string) => localStorage.setItem(refreshToken, refresh_token);
const getRefreshToken = () => localStorage.getItem(refreshToken);
const setRefreshTokenExpiredTime = (time: string) => localStorage.setItem(refreshTokenExpiresAt, time);
const getRefreshTokenExpiredTime = () => localStorage.getItem(refreshTokenExpiresAt);
const getUserId = () => localStorage.getItem(userId);

const setLoginInfo = (data: any) => {
  const { id, token, token_expires_at, refresh_token, refresh_token_expires_at } = data;
  setUserId(id);
  setAuthToken(token);
  setAuthTokenExpiredTime(token_expires_at);
  setRefreshToken(refresh_token);
  setRefreshTokenExpiredTime(refresh_token_expires_at);
}

const deleteAuthToken = () => localStorage.removeItem(loginTokenKey);
export {
  refreshTokenExpiresAt,
  getAuthToken,
  setAuthToken,
  deleteAuthToken,
  setLoginInfo,
  setAuthTokenExpiredTime,
  getAuthTokenExpiredTime,
  setRefreshToken,
  getRefreshToken,
  setRefreshTokenExpiredTime,
  getRefreshTokenExpiredTime,
  setUserId,
  getUserId,
};